var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8341 1.66509C15.2846 0.111635 12.7649 0.111635 11.2154 1.66509L0.913966 11.964C0.833426 12.0445 0.783568 12.1481 0.768227 12.2593L0.00501224 17.9131C-0.0179993 18.0742 0.0395295 18.2353 0.150752 18.3466C0.246633 18.4425 0.380867 18.5 0.5151 18.5C0.538112 18.5 0.561123 18.5 0.584135 18.4962L3.98984 18.0359C4.27364 17.9975 4.47308 17.7367 4.43472 17.4529C4.39637 17.169 4.13558 16.9696 3.85177 17.0079L1.12107 17.3761L1.65417 13.433L5.80391 17.5833C5.89979 17.6792 6.03402 17.7367 6.16826 17.7367C6.30249 17.7367 6.43672 17.683 6.53261 17.5833L16.8341 7.2844C17.5858 6.5326 18 5.53532 18 4.47283C18 3.41034 17.5858 2.41306 16.8341 1.66509ZM12 3.5L12.5 4L3 13.433L2.5 13L12 3.5ZM16.2933 6.34465L12.1551 2.20593C12.6805 1.77249 13.3363 1.53468 14.0267 1.53468C14.8129 1.53468 15.5493 1.84154 16.1054 2.39388C16.6615 2.94622 16.9645 3.68651 16.9645 4.47283C16.9645 5.16709 16.7267 5.81916 16.2933 6.34465Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPost);
export default __webpack_public_path__ + "static/media/edit-post.74be2557.svg";
export { ForwardRef as ReactComponent };